import { render, staticRenderFns } from "./ShuttleCreateOrUpdate.vue?vue&type=template&id=289d227d"
import script from "./ShuttleCreateOrUpdate.vue?vue&type=script&lang=js"
export * from "./ShuttleCreateOrUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports